/* eslint-disable no-undef */
// import * as DefaultConfig from "../config.local.json";
import * as DefaultConfig from "../config.json";

/**
 * Define default config
 */
export const $config = {
  API_URL: "",
  APP_VERSION: `${DefaultConfig.name}/@${DefaultConfig.versionName}`,
  APP_DEPRECATED: false,
  APP_URL: DefaultConfig.appURL,
  SERVICE_AUTH_URL: DefaultConfig.URLServiceAuth,
  SERVICE_API_URL: DefaultConfig.URLServiceApi,
};

/**
 * Get defined config
 */
export function getConfig() {
  return $config;
}

/**
 * Setup config from remote on production
 */
export function setConfig() {
  if (process.env.NODE_ENV === "development") {
    console.groupCollapsed("APP CONFIG");
    console.table($config);
    console.groupEnd();
  }

  return $config;
}
